/* Standard UI taps use existing click handlers, even when iOS omits compatibility clicks. */
(()=>{'use strict';
  const surfaces='.rail-category-button,#shapesLibraryButton,.category-tools-panel,.shapes-flyout';
  // These controls already own pointer gestures or have their own touch activation.
  const owned='.first-run-guide,.first-run-welcome,.first-run-restart,#runTutorial,.first-run-practice-banner,.axisRotateHandle,.edgeGizmoArrow,.heightResizeBadge';
  const buttonFor=target=>{
    const button=target?.closest?.('button,summary');
    if(!button||button.disabled||button.closest('[inert],[hidden],[aria-disabled="true"]')||button.closest(owned)||button.onpointerdown||button.onpointerup)return null;
    return button;
  };
  const hover=event=>event.pointerType!=='touch'&&window.matchMedia('(any-hover: hover)').matches;
  let gesture=null,activating=false;const ignore=new WeakMap();
  const now=()=>performance.now();
  const scrollState=button=>{const list=[];for(let node=button.parentElement;node;node=node.parentElement)list.push([node,node.scrollLeft,node.scrollTop]);return list;};
  for(const type of ['pointerenter','pointerleave'])document.addEventListener(type,event=>{
    if(event.target.closest?.(surfaces)&&!hover(event))event.stopImmediatePropagation();
  },true);
  document.addEventListener('pointerdown',event=>{
    if(event.pointerType!=='touch')return;
    const button=buttonFor(event.target);
    gesture=button&&event.isPrimary?{button,id:event.pointerId,x:event.clientX,y:event.clientY,time:now(),scroll:scrollState(button)}:null;
  },true);
  document.addEventListener('pointermove',event=>{
    if(gesture?.id===event.pointerId&&Math.hypot(event.clientX-gesture.x,event.clientY-gesture.y)>10)gesture=null;
  },true);
  document.addEventListener('pointercancel',()=>{gesture=null;},true);
  document.addEventListener('pointerup',event=>{
    if(event.pointerType!=='touch')return;
    const start=gesture;gesture=null;
    if(!start||start.id!==event.pointerId||start.button!==buttonFor(event.target)||now()-start.time>750||Math.hypot(event.clientX-start.x,event.clientY-start.y)>10||start.scroll.some(([node,x,y])=>node.scrollLeft!==x||node.scrollTop!==y))return;
    event.preventDefault();ignore.set(start.button,now()+1000);
    activating=true;try{start.button.click();}finally{activating=false;}
  },true);
  document.addEventListener('click',event=>{
    const button=event.target?.closest?.('button,summary');
    const compatibility=event.detail!==0||event.pointerType==='touch';
    if(button&&!activating&&compatibility&&now()<(ignore.get(button)||0)){event.preventDefault();event.stopImmediatePropagation();}
  },true);
})();

/* Local, opt-in diagnostics. Nothing is recorded or transmitted off this page. */
(()=>{'use strict';
  if(new URLSearchParams(location.search).get('touch-debug')!=='1')return;
  const panel=document.createElement('aside'),heading=document.createElement('strong'),output=document.createElement('pre'),close=document.createElement('button');
  panel.id='myerscadTouchCheck';panel.setAttribute('aria-label','Touch diagnostics');
  panel.style.cssText='position:fixed;z-index:2147483647;right:6px;bottom:calc(8px + env(safe-area-inset-bottom));width:min(330px,calc(100vw - 76px));box-sizing:border-box;padding:10px;background:#122c35;color:#fff;border:2px solid #61d8bc;border-radius:10px;font:12px/1.4 system-ui;pointer-events:auto;max-height:40dvh;overflow:auto';
  heading.textContent='MyersCAD · Touch check C';
  close.type='button';close.textContent='×';close.setAttribute('aria-label','Hide touch diagnostics');close.style.cssText='float:right;min-width:36px;min-height:36px;background:#244750;color:white;border:1px solid #6d9b9b;border-radius:5px;touch-action:manipulation';close.onclick=()=>{panel.hidden=true;};
  output.style.cssText='font:11px/1.45 ui-monospace,monospace;white-space:pre-wrap;margin:8px 0 0;overflow-wrap:anywhere';
  panel.append(close,heading,output);document.body.append(panel);
  const label=node=>node?(node.id||node.getAttribute?.('aria-label')||node.tagName||'?').slice(0,45):'none';
  const lines=[];let snapshot='',delayed=0,lastError='';
  function read(){
    const expanded=document.querySelector('.rail-category-button[aria-expanded=true],#shapesLibraryButton[aria-expanded=true]');
    const menu=expanded&&document.getElementById(expanded.getAttribute('aria-controls'));
    const locks=document.querySelectorAll('[inert]').length;
    let result='Open: '+label(expanded)+' | inert: '+locks;
    if(menu){const r=menu.getBoundingClientRect(),style=getComputedStyle(menu),x=Math.max(0,Math.min(innerWidth-1,r.left+r.width/2)),y=Math.max(0,Math.min(innerHeight-1,r.top+r.height/2)),hit=document.elementFromPoint(x,y);result+='\nMenu '+Math.round(r.left)+','+Math.round(r.top)+' '+Math.round(r.width)+'×'+Math.round(r.height)+' '+style.display+'/'+style.visibility+'\nHit: '+label(hit)+' | inside: '+!!(hit&&menu.contains(hit));}
    const fatal=document.getElementById('fatal');if(fatal&&!fatal.hidden)result+='\nError: '+fatal.textContent.slice(0,160);
    if(lastError)result+='\nLast JS error: '+lastError;
    return result;
  }
  function render(){output.textContent='UI touch fix C loaded · '+innerWidth+'×'+innerHeight+'\n'+lines.join('\n')+'\n'+snapshot;}
  function sample(phase){snapshot=phase+' · '+read();render();}
  for(const type of ['pointerdown','pointerup','pointercancel','click'])window.addEventListener(type,event=>{
    if(panel.contains(event.target))return;
    const target=event.target.closest?.('button,summary,canvas')||event.target;
    lines.push(type+' '+(event.pointerType||'—')+' '+label(target)+(event.isTrusted?'':' [script]'));
    while(lines.length>5)lines.shift();
    requestAnimationFrame(()=>sample('now'));clearTimeout(delayed);delayed=setTimeout(()=>sample('after 350ms'),350);
  },true);
  window.addEventListener('error',event=>{lastError=String(event.message).slice(0,140);lines.push('JS error: '+lastError);while(lines.length>5)lines.shift();sample('error');});
  sample('ready');
})();
